<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Assign Status</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <div style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px"> 
            <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Status Type</mat-label>
                <input matInput placeholder="Status Type"  type="text" [(ngModel)]="statusTypeName" disabled>
            </mat-form-field>
            <div class="flex-end">
              <button mat-raised-button color="accent" (click)="redirectToAddStatusPage()">Add Status<mat-icon>add</mat-icon></button>
            </div>
            <div class="status_list">
                <ul>
                    <li *ngFor="let item of itemList">
                        <mat-checkbox [checked]="selection.isSelected(item)" (change)="handleStatusChange(item)">{{item?.statusName}}</mat-checkbox>
                        <span (click)="redirectToUpdateStatusPage(item)"><mat-icon>edit</mat-icon></span>
                    </li>
                </ul>
            </div>
         </div>

         <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          <button mat-button type="button" class="sub-button" (click)="assignClaimStatus()">Assign</button>
          <button class="can-button" (click)="redirectToStatusTypePage()" mat-button>Cancel</button>
        </div>
           
           
    </div>
    </div>
  </div>
  